import { createContext, useContext } from 'react';

// App-wide region/variant of the LPA site. Persisted per-browser in localStorage.
// Future US-specific logic (code generator rules, PDF formats, etc.) should branch
// on this value via useRegion() so nothing needs re-plumbing.
export const REGIONS = {
  AU: { code: 'AU', label: 'AU', name: 'Australia' },
  US: { code: 'US', label: 'US', name: 'United States' },
};

export const REGION_STORAGE_KEY = 'lpa_region';

export const RegionContext = createContext('AU');
export const useRegion = () => useContext(RegionContext);
